// document.addEventListener('DOMContentLoaded', function() {
//   // ... (previous Liquid and JavaScript code to set up productData and event listener) ...

//   var variantSelectElement = document.querySelector('select[name="options[Finish]"]');
//   var leadTimeContainer = document.querySelector('#product-lead-time');
//   var leadTimeDisplay = leadTimeContainer.querySelector('p');
 

//   if (variantSelectElement && leadTimeContainer && leadTimeDisplay) {
//     variantSelectElement.addEventListener('change', function() {
//       var selectedOptionValue = variantSelectElement.value;
//       var selectedVariant = productData.variants.find(function(variant) {
//         return variant.option1 === selectedOptionValue;
//       });

//       if (selectedVariant && selectedVariant.metafields && selectedVariant.metafields.details.lead_time !== null) {
//         leadTimeDisplay.textContent = selectedVariant.metafields.details.lead_time;
//         leadTimeContainer.style.display = 'block'; // Or 'inline-block', 'flex', etc. depending on your layout need
//       } else {
//           // If no specific lead time is set in the metafield, check inventory
//           if (selectedVariant.inventory_quantity > 0) {
//             leadTimeDisplay.textContent = 'Typically ships in 3-5 business days';
//             leadTimeContainer.style.display = 'block'; // Or 'inline-block', 'flex', etc.
//           } else {
//             leadTimeDisplay.textContent = 'Typically ships in 2-3 weeks';
//             leadTimeContainer.style.display = 'block'; // Or 'inline-block', 'flex', etc.
//           }
//           // Call the function on initial page load to show the lead time for the pre-selected variant
//           updateLeadTimeMessage();

//           // Add an event listener to update the message when the 'Finish' option changes
//           variantSelectElement.addEventListener('change', updateLeadTimeMessage);
//         }
//     });
//   }
// });


// document.addEventListener('DOMContentLoaded', function() {
//   // ... (previous Liquid and JavaScript code to set up productData and event listener) ...

//   var variantSelectElement = document.querySelector('select[name="options[Finish]"]');
//   var leadTimeContainer = document.querySelector('#product-lead-time');
//   var leadTimeDisplay = leadTimeContainer.querySelector('p');

//   if (variantSelectElement && leadTimeContainer && leadTimeDisplay) {

//     // Function to update the lead time message
//     function updateLeadTimeMessage() {
//       var selectedOptionValue = variantSelectElement.value;
//       var selectedVariant = productData.variants.find(function(variant) {
//         return variant.option1 === selectedOptionValue;
//       });

//       if (selectedVariant) { // Ensure a variant is found
//         if (selectedVariant.metafields && selectedVariant.metafields.details && selectedVariant.metafields.details.lead_time !== null) {
//           leadTimeDisplay.textContent = selectedVariant.metafields.details.lead_time;
//           leadTimeContainer.style.display = 'block'; 
//         } else {
//             // Check for available inventory or rely on a fallback
//             // This is the core change: use variant.available or fetch current inventory data
//             if (selectedVariant.available) { 
//               leadTimeDisplay.textContent = 'Typically ships in 3-5 business days';
//               leadTimeContainer.style.display = 'block'; 
//             } else {
//               leadTimeDisplay.textContent = 'Typically ships in 2-3 weeks';
//               leadTimeContainer.style.display = 'block'; 
//             }
//         }
//       } else { // No variant selected
//           leadTimeContainer.style.display = 'none'; // Hide lead time if no variant is selected
//       }
//     }

//     // Call the function on initial page load to show the lead time for the pre-selected variant
//     updateLeadTimeMessage();

//     // Add an event listener to update the message when the 'Finish' option changes
//     variantSelectElement.addEventListener('change', updateLeadTimeMessage);
//   }
// });


document.addEventListener('DOMContentLoaded', function() {
  var variantSelectElement = document.querySelector('select[name="options[Finish]"]');
  var leadTimeContainer = document.querySelector('#product-lead-time');
  var leadTimeDisplay = leadTimeContainer.querySelector('p');

  if (variantSelectElement && leadTimeContainer && leadTimeDisplay) {
    function updateLeadTimeMessage() {
      var selectedOptionValue = variantSelectElement.value;
      var selectedVariant = productData.variants.find(function(variant) {
        return variant.option1 === selectedOptionValue;
      });

      if (selectedVariant) { // Ensure a variant is found
        if (selectedVariant.metafields && selectedVariant.metafields.details && selectedVariant.metafields.details.lead_time !== null) {
          leadTimeDisplay.textContent = selectedVariant.metafields.details.lead_time;
          leadTimeContainer.style.display = 'block'; 
        } else if (selectedVariant.available) { 
          leadTimeDisplay.textContent = 'Typically ships in 3-5 business days';
          leadTimeContainer.style.display = 'block'; 
        } else { // No specific lead time or out of stock
          leadTimeDisplay.textContent = 'Typically ships in 2-3 weeks';
          leadTimeContainer.style.display = 'block'; 
        }
      } else { // No variant selected or product data unavailable
          leadTimeContainer.style.display = 'none'; // Hide lead time if no variant is selected
          console.error("No variant found for selected option or productData is missing.");
      }
    }

    updateLeadTimeMessage();

    variantSelectElement.addEventListener('change', updateLeadTimeMessage);
  } else {
    console.error("One or more required elements (variantSelectElement, leadTimeContainer, leadTimeDisplay) not found.");
  }
});



// With else if statement
// document.addEventListener('DOMContentLoaded', function() {
//   // ... (previous Liquid and JavaScript code to set up productData and event listener) ...

//   var variantSelectElement = document.querySelector('select[name="options[Finish]"]');
//   var leadTimeContainer = document.querySelector('#product-lead-time');
//   var leadTimeDisplay = leadTimeContainer.querySelector('p');

//   if (variantSelectElement && leadTimeContainer && leadTimeDisplay) {
//     variantSelectElement.addEventListener('change', function() {
//       var selectedOptionValue = variantSelectElement.value;
//       var selectedVariant = productData.variants.find(function(variant) {
//         return variant.option1 === selectedOptionValue;
//       });

//       if (selectedVariant && selectedVariant.metafields && selectedVariant.metafields.details.lead_time !== null) {
//         leadTimeDisplay.textContent = selectedVariant.metafields.details.lead_time;
//         leadTimeContainer.style.display = 'block'; // Or 'inline-block', 'flex', etc. depending on your layout need
//       } else if (selectedVariant && selectedVariant.inventory_quantity > 0) { // Corrected line: added condition
//         // If no specific lead time is set in the metafield, check inventory
//         leadTimeDisplay.textContent = 'Typically ships in 3-5 business days';
//         leadTimeContainer.style.display = 'block'; // Or 'inline-block', 'flex', etc.
//       } else {
//         leadTimeDisplay.textContent = 'Typically ships in 2-3 weeks';
//         leadTimeContainer.style.display = 'block'; // Or 'inline-block', 'flex', etc.
//       }

//       // Call the function on initial page load to show the lead time for the pre-selected variant
//       // updateLeadTimeMessage(); // This call is outside the scope of the original problem and likely needs to be defined
//     });

//     // Add an event listener to update the message when the 'Finish' option changes
//     // variantSelectElement.addEventListener('change', updateLeadTimeMessage); // This listener is redundant if already set up above
//   }
// });



// document.addEventListener('DOMContentLoaded', function() {
//   // ... (previous Liquid and JavaScript code to set up productData and event listener) ...

//   var variantSelectElement = document.querySelector('select[name="options[Finish]"]');
//   var leadTimeContainer = document.querySelector('#product-lead-time');
//   var leadTimeDisplay = leadTimeContainer.querySelector('p');

//   if (variantSelectElement && leadTimeContainer && leadTimeDisplay) {
//     variantSelectElement.addEventListener('change', function() {
//       var selectedOptionValue = variantSelectElement.value;
//       var selectedVariant = productData.variants.find(function(variant) {
//         return variant.option1 === selectedOptionValue;
//       });

//       if (selectedVariant && selectedVariant.metafields && selectedVariant.metafields.details.lead_time !== null) {
//         leadTimeDisplay.textContent = selectedVariant.metafields.details.lead_time;
//         leadTimeContainer.style.display = 'block';
//       } else {
//         // Find the div containing "In stock now" or "Check for stock availability"
//         var textContainer = document.querySelector('.inventory span.advantage'); // Replace with the actual selector for the div that holds the text.
        
//         if (textContainer && textContainer.textContent.includes('In stock now')) { // Use textContent and includes() to check for the text
//           leadTimeDisplay.textContent = 'Typically ships in 3-5 business days';
//           leadTimeContainer.style.display = 'block';
//         } else if (textContainer && textContainer.textContent.includes('Check for stock availability')) {
//           leadTimeDisplay.textContent = 'Typically ships in 2-3 weeks';
//           leadTimeContainer.style.display = 'block';
//         } 
//       }
//     });

//     // Initial call to set lead time on page load
//     var initialOptionValue = variantSelectElement.value;
//     var initialVariant = productData.variants.find(function(variant) {
//       return variant.option1 === initialOptionValue;
//     });

//     if (initialVariant && initialVariant.metafields && initialVariant.metafields.details.lead_time !== null) {
//       leadTimeDisplay.textContent = initialVariant.metafields.details.lead_time;
//       leadTimeContainer.style.display = 'block';
//     } else {
//       var textContainer = document.querySelector('.inventory span.advantage'); // Replace with the actual selector for the div that holds the text.

//       if (textContainer && textContainer.textContent.includes('In stock now')) {
//         leadTimeDisplay.textContent = 'Typically ships in 3-5 business days';
//         leadTimeContainer.style.display = 'block';
//       } else if (textContainer && textContainer.textContent.includes('Check for stock availability')) {
//         leadTimeDisplay.textContent = 'Typically ships in 2-3 weeks';
//         leadTimeContainer.style.display = 'block';
//       } 
//     }
//   }
// });


// document.addEventListener('DOMContentLoaded', function() {
//   // ... (previous Liquid and JavaScript code to set up productData) ...
//   var variantSelectElement = document.querySelector('select[name="options[Finish]"]');
//   var leadTimeContainer = document.querySelector('#product-lead-time');
//   var leadTimeDisplay = leadTimeContainer.querySelector('p');

//   if (variantSelectElement && leadTimeContainer && leadTimeDisplay) {
//       // Define the updateLeadTimeMessage function
//       function updateLeadTimeMessage() {
//           var selectedOptionValue = variantSelectElement.value;
//           var selectedVariant = productData.variants.find(function(variant) {
//               return variant.option1 === selectedOptionValue;
//           });

//           if (selectedVariant && selectedVariant.metafields && selectedVariant.metafields.details.lead_time !== null) {
//               leadTimeDisplay.textContent = selectedVariant.metafields.details.lead_time;
//               leadTimeContainer.style.display = 'block'; // Or 'inline-block', 'flex', etc.
//           } else {
//               // If no specific lead time is set in the metafield, check inventory
//               if (selectedVariant.inventory_quantity > 0) {
//                   leadTimeDisplay.textContent = 'Typically ships in 3-5 business days';
//                   leadTimeContainer.style.display = 'block'; // Or 'inline-block', 'flex', etc.
//               } else {
//                   leadTimeDisplay.textContent = 'Typically ships in 2-3 weeks';
//                   leadTimeContainer.style.display = 'block'; // Or 'inline-block', 'flex', etc.
//               }
//           }
//       }

//       // Call the function on initial page load to show the lead time for the pre-selected variant
//       updateLeadTimeMessage();

//       // Add an event listener to update the message when the 'Finish' option changes
//       variantSelectElement.addEventListener('change', updateLeadTimeMessage);
//   }
// });



